/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useHistory, useLocation, Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import { Button } from "@utahdts/utah-design-system";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import DwriTabs from "./DwriTabs";
import DwriDataTab from "./tabs/DwriDataTab";
import DwriCalculationsTab from "./tabs/DwriCalculationsTab";
import DwriReportTab from "./tabs/DwriReportTab";

const DwriDataContainer = () => {
    const history = useHistory();
    const location = useLocation();
    const { path } = useRouteMatch();

    const [activeTab, setActiveTab] = useState("dwri-data");

    // Sync active tab with URL
    useEffect(() => {
        const lastSegment = location.pathname.split("/").pop();
        if (["dwri-data", "calculations", "report"].includes(lastSegment)) {
            setActiveTab(lastSegment);
        }
    }, [location]);

    const handleTabChange = (tabId) => {
        history.push(`${path}/${tabId}`, location.state);
    };

    const handleBack = () => {
        history.push("/engineering/dwri/dwri-data-search");
    }

    return (
        <div className="utah-design-system page-container">
            <div className="mb-3">
                 <Button variant="secondary" onClick={handleBack}>
                    <FontAwesomeIcon icon={faArrowLeft} className="me-2" /> Back to Search
                </Button>
            </div>
            
            <DwriTabs activeTab={activeTab} onTabChange={handleTabChange} />

            <div className="mt-4">
                <Switch>
                    <Route path={`${path}/dwri-data`}>
                        <DwriDataTab />
                    </Route>
                    <Route path={`${path}/calculations`}>
                         <DwriCalculationsTab />
                    </Route>
                     <Route path={`${path}/report`}>
                         <DwriReportTab />
                    </Route>
                     <Redirect exact from={path} to={`${path}/dwri-data`} />
                </Switch>
            </div>
        </div>
    );
};

export default DwriDataContainer;